import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  otpOuterSection: {
    justifyContent: "center",
    marginTop: "42px",
    marginBottom: "15px",
  },
  otpHeading: {
    marginTop: "20px",
    left: "68px",
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "16.71px",
    color: "#000000",
    textAlign: "center",
  },
  otpInnerSection: {
    display: "flex",
    justifyContent: "center",
    marginTop: "5px",
    marginBottom: "0px",
  },
  otpWrapper: {
    width: "395px",
    height: "67px",
    display: "flex",
    flexDirection: "row",
    marginTop: "30px",
    left: "65px",
    justifyContent: "center",
  },
  otpDigit: {
    width: "41px",
    height: "45px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    backgroundColor: "#D9D9D9",
    margin: "5px",
    fontSize: "20px",
    border: 0,
    fontWeight: "bold",
    borderRadius: "4px",
  },
  otpErrorSection: {
    textAlign: "center",
    fontSize: "10px",
    marginBottom: "20px",
  },
}));
